import React from 'react';

import { Dialog } from '@icedesign/base';
import Img from '@icedesign/img';

import { Link } from 'react-router-dom';

import { getAuthority } from '@/auth/authority';
import Auths from '@/auth/Auths';
import Editions from '@/constants/Editions';
import getEditionTypes from '@/constants/EditionTypes';
import { formatMessage } from '@/i18n';
import version from '@/version';

const AboutDialog = ({ systemInfo, visible, onClose }) => {
  const EditionTypes = getEditionTypes();
  const edition = systemInfo?.edition || Editions.LITE;
  const appLogo = systemInfo?.appLogo || 'images/logo.png';
  const upgradable =
    getAuthority().includes(Auths.SUPER) && (edition === Editions.LITE || edition === Editions.STD);

  return (
    <Dialog
      style={{ width: '700px' }}
      visible={visible}
      onClose={onClose}
      onCancel={onClose}
      closable="esc, mask, close"
      title={formatMessage('menu.header.about')}
      language={formatMessage('language')}
      footer={false}
      autoFocus={false}
    >
      <div style={styles.formDiv}>
        <div style={styles.formContent}>
          <Img
            enableAliCDNSuffix
            type="cover"
            shape="circle"
            width={120}
            height={120}
            src={`${appLogo}?time=${new Date().getTime()}`}
            style={{ borderRadius: '50%', margin: '10px' }}
          />
          {systemInfo?.appName && <div style={styles.formTitle}>{systemInfo.appName}</div>}
          <div style={styles.formDetail}>
            <div style={styles.formItem}>
              <span>
                {`${formatMessage('system.about.edition')}：${EditionTypes[edition]}`}
                {upgradable && (
                  <>
                    &nbsp;
                    <Link to="/system/edition">({formatMessage('system.license.upgrade')})</Link>
                  </>
                )}
              </span>
              <span>{`${formatMessage('system.about.version')}：${version.code}`}</span>
            </div>
            <div style={styles.formItem}>
              {`${formatMessage('system.about.copyright')}：© 2001 - ${new Date().getFullYear()}`}
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default AboutDialog;

const styles = {
  formDiv: {
    display: 'flex',
    justifyContent: 'center',
  },
  formContent: {
    position: 'relative',
    width: '750px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  formTitle: {
    fontSize: '28px',
    fontFamily: 'Helvetica, sans-serif',
    fontWeight: 'bold',
    color: '#666666',
    margin: '10px 0 20px 0',
  },
  formDetail: {
    width: '80%',
    margin: '20px 0',
  },
  formItem: {
    display: 'flex',
    justifyContent: 'space-between', // 两端对齐
    alignItems: 'center', // 垂直居中
    width: '100%',
    color: '#333333',
    margin: '15px 0',
  },
};
